export default __webpack_public_path__ + "static/media/Dots with curved.b547c3e4.svg";